<template>
  <v-container fluid grid-list-md style="padding: 35px;" id="create">
    <!-- <v-card
      class="elevation-1"
      style="border-radius: 10px;padding: 20px;"> -->
    <v-flex xs12 sm12 md12 lg12>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <p class="textoUser">DASHBOARD - AIPASS</p>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="6">
          <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" label="Selecione o Evento" @input="carregaValores()" color="#0D47A1"></v-select>
        </v-col> -->
        <v-col cols="12" sm="12" md="2">
          <v-speed-dial v-model="fab" top right direction="left" transition="slide-y-reverse-transition" class="py-0" style="margin-right: 16px;">
            <template v-slot:activator>
              <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }"> -->
              <v-btn v-model="fab" color="#7B1FA2" dark fab>
                <v-icon large>swap_vert</v-icon>
              </v-btn>
            </template>
            <!-- <span>Controle</span>
            </v-tooltip>
            </template> -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab v-on="on" dark @click="openDialog('CHECKIN')" color="#388E3C">
                  <v-icon large>arrow_circle_down</v-icon>
                </v-btn>
              </template>
              <span>CheckIn</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab dark v-on="on" color="#D32F2F" @click="openDialog('CHECKOUT')">
                  <v-icon large>arrow_circle_up</v-icon>
                </v-btn>
              </template>
              <span>CheckOut</span>
            </v-tooltip>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#7B1FA2" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Vendas</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Dia</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size:50px;padding:12px;">{{capacidade}}</v-card-text>
              </div>
              <v-avatar size="120" tile color="#4A148C" style="border-top-right-radius: 10px;">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="100" color="white">100%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#FFA000" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Vendas</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Semanal</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size:50px;padding:12px;">{{reservados}}</v-card-text>
              </div>
              <v-avatar size="120" tile color="#FF8F00" style="border-top-right-radius: 10px;">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percenteReserv" color="white">{{ percenteReserv.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#43A047" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Vendas</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Mensal</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size:50px;padding:12px;">{{inscritos}}</v-card-text>
              </div>
              <v-avatar size="120" tile color="#388E3C" style="border-top-right-radius: 10px;">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentInscri" color="white">{{ percentInscri.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#1565C0" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Total</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Pedidos</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size:50px;padding:12px;">{{inscritosPagos}}</v-card-text>
              </div>
              <v-avatar size="120" tile color="#0D47A1" style="border-top-right-radius: 10px;">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentConfirm" color="white">{{ percentConfirm.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#0097A7" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Meus Checkins</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Realizados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size:50px;padding:12px;">{{checkinsRealizados}}</v-card-text>
              </div>
              <v-avatar size="120" tile color="#006064" style="border-top-right-radius: 10px;">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentCheckinUser" color="white">{{ percentCheckinUser.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
            </div>
          </v-card>
        </v-col> -->
        <!-- <v-col cols="12" sm="12" md="4" lg="3">
          <v-card max-height="120px" color="#F4511E" dark style="border-radius: 10px;">
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title style="margin-top: -9px;" class="headline">Total Checkins</v-card-title>
                <v-card-subtitle style="margin-bottom: -8px;">Realizados</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text style="font-size:50px;padding:12px;">{{checkinsRealizadosTotal}}</v-card-text>
              </div>
              <v-avatar size="120" tile color="#BF360C" style="border-top-right-radius: 10px;">
                <v-progress-circular :rotate="360" :size="100" :width="15" :value="percentCheckinTotal" color="white">{{ percentCheckinTotal.toFixed(0) }}%</v-progress-circular>
              </v-avatar>
              <v-avatar size="120" tile color="#BF360C" style="border-top-right-radius: 10px;">
                <v-icon x-large>fact_check</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col> -->
      </v-row>
      <v-row>
        <v-dialog v-model="dialog" max-width="350px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto" style="margin-bottom: -23px">{{acao}}</span>
            </v-card-title>
            <v-card-text v-if="!validacao" style="text-align: center;padding: 0px 5px 0px">
              <v-container>
                <v-row align="center" justify="center" v-if="acao=='CHECKOUT'">
                  <v-col cols="12" sm="6" md="12">
                    <p class="texto" :style="`color:${corValidacao}`">{{evento}}</p>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center" v-if="acao=='CHECKIN'">
                  <v-col cols="12" sm="6" md="12">
                    <v-radio-group v-model="tipo" row hide-details>
                      <v-radio color="#7B1FA2" label="QRCODE" value="1"></v-radio>
                      <v-radio color="#7B1FA2" label="CÓDIGO" value="2"></v-radio>
                      <v-radio color="#7B1FA2" label="CPF" value="3"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo=='1'">
                    <qrcode-stream @decode="onDecode"></qrcode-stream>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo=='2'">
                    <v-text-field light label="CÓDIGO" color="#7B1FA2" type="tel" outlined hide-details dense v-model="codigo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" v-if="tipo=='3'">
                    <v-text-field light label="CPF" color="#7B1FA2" outlined v-mask="'###.###.###-##'" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-text v-if="validacao" style="text-align: center;padding: 0px 5px 0px;">
              <v-container>
                <br>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <v-icon large :color="corValidacao" style="font-size: 100px">{{iconValidacao}}</v-icon>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" style="padding: 2px;" v-if="participantes > 1">
                    <p class="texto" :style="`color:${corValidacaoParticipantes}; font-size: 20px; background-color: ${corValidacao}; padding: 10px`"><b>{{participantes}} participantes</b></p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" :style="`color:${corValidacao}; font-size: 17px`"><b>{{msgValidacao}}</b></p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions v-if="!validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs6 sm6 lg6 v-if="tipo!=1">
                    <v-btn :loading="loading" dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="validarInscricao">Validar</v-btn>
                  </v-flex>
                  <v-flex xs6 sm6 lg6>
                    <v-btn dark depressed block color="#D32F2F" style="border-radius: 7px;" large @click="close">Fechar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
            <v-card-actions v-if="validacao" style="margin-top: -32px;padding: 20px 5px 0px;">
              <v-container fluid grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg12>
                    <v-btn dark depressed block color="#4A148C" style="border-radius: 7px;" large @click="closeResultado">Fechar</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- <v-col cols="12" sm="12" md="12">
            <v-alert
            :icon="iconMsg"
            prominent
            text
            :color="corMsg"
          >
          <span style="font-weight: bold;">{{msgPontuacao}}</span> {{descPontuacao}}
          </v-alert>
          </v-col> -->
        <!-- <v-col cols="12" sm="12" md="6">
          <v-card style="border-radius: 10px;padding: 10px;">
            <v-card-title style="justify-content: center;">Pesquisas realizadas nos últimos {{diasSelc}} dias</v-card-title>
            <graph-bar
                :width="600"
                :height="300"
                :align="'center'"
                textAlign="center"
                :axis-min="0"
                showTex
                :colors="colors"
                :axis-max="100"
                :labels="datasGrap"
                :axisFormat="true"
                :values="pontuacaoTotal">
                <tooltip :names="names" :position="'center'"></tooltip>
                <legends :names="names" :filter="true"></legends>
            </graph-bar>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-card style="border-radius: 10px;padding: 10px;">
            <v-card-title style="justify-content: center;">Evolução do NPS nos últimos {{diasSelc}} dias</v-card-title>
            <graph-line
                :width="600"
                :height="300"
                :align="'center'"
                textAlign="center"
                :shape="'normal'"
                :axis-min="-100"
                :axis-max="100"
                :display="'all'"
                :colors="colorLine"
                :axis-full-mode="true"
                :labels="datasGrap"
                names="Pontuação NPS"
                :values="pontuacaoDia">
                <tooltip :names="namesLine" :position="'center'"></tooltip>
                <legends :names="namesLine"></legends>
                <guideline :tooltip-y="true"></guideline>
            </graph-line>
          </v-card>
        </v-col> -->
      </v-row>
    </v-flex>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7B1FA2" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import {
  baseApiUrl
} from '@/global'
import axios from 'axios'
import {
  mapState
} from 'vuex'
import moment from 'moment'
import Snackbar from '../componentes/snackbar.vue'
export default {
  components: {
    Snackbar,
    Loading
  },
  data() {
    return {
      diasSelc: 7,
      corSelec: '#388E3C',
      fab: false,
      fullPage: true,
      isLoading: false,
      eventoId: '',
      eventos: [],
      capacidade: 0,
      inscritos: 0,
      inscritosPagos: 0,
      checkinsRealizados: 0,
      checkinsRealizadosTotal: 0,
      reservados: 0,
      confirmados: 0,
      percentCapac: 0,
      percenteReserv: 0,
      percentInscri: 0,
      percentConfirm: 0,
      percentCheckinTotal: 0,
      percentCheckinUser: 0,
      dialog: false,
      codigo: '',
      cpf: '',
      tipo: '1',
      acao: '',
      evento: '',
      validacao: false,
      loading: false,
      msgValidacao: '',
      iconValidacao: '',
      corValidacao: '',
      contador: '',
      checkin: {
        cod_incricao: '',
        tipo: '',
        eventoId: '',
        userValidatorId: '',
      },
      defaultCheckin: {
        cod_incricao: '',
        tipo: '',
        eventoId: '',
        userValidatorId: '',
      },
      audio: '',
      usaQrcode: false,
      qtdVigilantes: 0,
      qtdApoio: 0,
      qtdBasico: 0,
      qtdGrandesEventos: 0,
      qtdEmAnalise: 0,
      qtdAtivos: 0,
      participantes: 0,
      corValidacaoParticipantes: '#FFFFFF'
    }
  },
  computed: {
    ...mapState({
      usuarioadmin: state => state.Userpermission,
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

  },
  mounted() {
    this.carregaDados()
    this.inscricoesVigilantes()
    this.audio = new Audio(require("../assets/beep.mp3"))
    this.$validator.localize('pt', this.dictionary)
  },
  watch: {
    tipo(val) {
      if (val === '1') {
        this.cpf = ""
        this.$validator.reset()
      } else
      if (val === '2')
        this.codigo = ''
    }
  },

  methods: {

    onDecode(decodedString) {
      this.codigo = decodedString
      this.usaQrcode = true
      this.confirmaCheckin()
    },

    async carregaDados() {
      this.isLoading = true
      await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"${this.companyobj.id}"},{"ativo":"true"}]}}`)
        .then(res => {
          if (res.data != '') {
            for (var key in res.data) {
              if (res.data.hasOwnProperty(key)) {
                if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                  this.eventos.push(res.data[key])

                }

              }
            }

            this.eventos = this.eventos.sort(this.compare)
            this.eventoId = this.eventos[0].id
          } else {
            this.isLoading = false
          }
        })
      await this.carregaValores()
    },
    formatDateBrz(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDatePadrao(date) {
      if (!date) return null

      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },
    compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const dataA = a.fim;
      const dataB = b.fim;

      let comparison = 0;
      if (dataA > dataB) {
        comparison = 1;
      } else if (dataA < dataB) {
        comparison = -1;
      }
      return comparison;
    },

    openDialog(acao) {
      if (acao == 'CHECKIN') {
        this.tipo = "1"
        this.audio.play()
      } else
        this.tipo = "0"
      this.codigo = ''
      this.cpf = ''

      this.acao = acao
      this.dialog = true
    },

    async validarInscricao() {
      this.checkin = Object.assign({}, this.defaultCheckin)
      this.loading = true
      if (this.acao == 'CHECKIN') {
        this.confirmaCheckin()
      } else
      if (this.acao == 'CHECKOUT') {
        this.confirmaCheckout()
      } else {
        this.loading = false
      }
    },

    async confirmaCheckin() {
      var vm = this;
      if (this.codigo != '') {
        this.checkin.cod_incricao = this.codigo
        this.checkin.tipo = this.acao
        this.checkin.eventoId = this.eventoId
        this.checkin.userValidatorId = this.user.id
        await axios.post(`${baseApiUrl}inscricoes/checkin`, this.checkin)
          .then(res => {
            if (res.data != '') {
              switch (res.data.codigo) {
                case 1:
                  //'Validação já efetuada anteriormente' 
                  if (this.usaQrcode)
                    this.audio.play()
                  this.participantes = res.data.participantes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 2:
                  //'Vagas esgotadas para o evento'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'cancel'
                  this.corValidacao = '#D32F2F'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 3:
                  //'Validação efetuada com sucesso'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.participantes = res.data.participantes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'check_circle_outline'
                  this.corValidacao = '#43A047'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 5:
                  //'Inscrição não localizada pra este evento'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'cancel'
                  this.corValidacao = '#D32F2F'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                case 8:
                  //'Inscrição com pagamento pendente'
                  if (this.usaQrcode)
                    this.audio.play()
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                default:
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
              }
            }
          }).catch(() => {
            this.isLoading = false
            this.close()
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
          })
      } else
      if (this.cpf != '') {
        await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"cpf":"${this.cpf}"},{"eventoId":"${this.eventoId}"}]}}`)
          .then(res => {
            if (res.data != '') {
              this.checkin.cod_incricao = res.data[0].cod_incricao
            } else {
              this.checkin.cod_incricao = 9999
            }
          })

        this.checkin.tipo = this.acao
        this.checkin.eventoId = this.eventoId
        this.checkin.userValidatorId = this.user.id
        await axios.post(`${baseApiUrl}inscricoes/checkin`, this.checkin)
          .then(res => {
            if (res.data != '') {
              switch (res.data.codigo) {
                case 1:
                  //'Validação já efetuada anteriormente'                    
                  this.participantes = res.data.participantes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  break;
                case 3:
                  //'Validação efetuada com sucesso'                    
                  this.participantes = res.data.participantes
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'check_circle_outline'
                  this.corValidacao = '#43A047'
                  this.validacao = true
                  this.loading = false
                  break;
                case 5:
                  //'Inscrição não localizada pra este evento'                    
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'cancel'
                  this.corValidacao = '#D32F2F'
                  this.validacao = true
                  this.loading = false
                  break;
                case 8:
                  //'Inscrição com pagamento pendente'
                  this.msgValidacao = res.data.resposta
                  this.iconValidacao = 'error_outline'
                  this.corValidacao = '#FF8F00'
                  this.validacao = true
                  this.loading = false
                  this.usaQrcode = false
                  break;
                default:
                  break;
              }
            }
          }).catch(() => {
            this.isLoading = false
            this.close()
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao realizar check-in, tente novamente", "DESCULPE")
          })
      } else
        this.loading = false

    },

    async confirmaCheckout() {
      this.checkin.cod_incricao = this.codigo
      this.checkin.tipo = this.acao
      this.checkin.eventoId = this.eventoId
      await axios.post(`${baseApiUrl}inscricoes/checkin`, this.checkin)
        .then(res => {
          if (res.data != '') {
            switch (res.data.codigo) {
              case 7:
                //'Checkout confirmado
                this.msgValidacao = res.data.resposta
                this.iconValidacao = 'check_circle_outline'
                this.corValidacao = '#43A047'
                this.validacao = true
                this.loading = false
                break;
              case 6:
                //'O local do evento está vazio'
                this.msgValidacao = res.data.resposta
                this.iconValidacao = 'error_outline'
                this.corValidacao = '#FF8F00'
                this.validacao = true
                this.loading = false
                break;
              default:
                break;
            }
          }
        })
    },

    async carregaValores() {
      for (var key in this.eventos) {
        if (this.eventos.hasOwnProperty(key)) {
          if (this.eventos[key].id == this.eventoId) {
            this.capacidade = this.eventos[key].vagas
            this.reservados = this.eventos[key].reserva
            this.evento = this.eventos[key].nome
          }

        }
      }
      /* await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
        .then(res => {
          this.inscritos = res.data.length
          this.confirmados = this.inscritos + this.reservados
        }) */

      // obtém a quantidade de inscrições realizadas e pagas
      await axios.post(`${baseApiUrl}Inscricoes/dashboard`, {"eventoId": this.eventoId})
      .then(res => {
        this.inscritos = res.data.inscritos
        this.inscritosPagos = res.data.confirmados
      })

      try {
        let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"eventoId":"${this.eventoId}"}}`)
            let inscricoes = res.data
            //this.checkinsRealizados = res.data
            inscricoes.forEach(inscrito => {
              if(inscrito.checkin != null && inscrito.userValidatorCheckinId == this.user.id){
                if(inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                    this.checkinsRealizados = this.checkinsRealizados + inscrito.participantes
                else
                    this.checkinsRealizados++
              }

              if(inscrito.checkin != null){
                if(inscrito.hasOwnProperty("participantes") && inscrito.participantes > 0)
                    this.checkinsRealizadosTotal = this.checkinsRealizadosTotal + inscrito.participantes
                else
                    this.checkinsRealizadosTotal++
              }
              
            });            
      } catch (error) {
        //
      }

      await this.calculaPercentuais()

    },

    async inscricoesVigilantes() {
      await axios.get(`${baseApiUrl}Vigilantes/count`).then(res => {
        this.qtdVigilantes = res.data.count
      })
      await axios.get(`${baseApiUrl}Vigilantes/count?where={"qualificacao":"APOIO"}`).then(res => {
        this.qtdApoio = res.data.count
      })
      await axios.get(`${baseApiUrl}Vigilantes/count?where={"qualificacao":"VIGILANTE BÁSICO"}`).then(res => {
        this.qtdBasico = res.data.count
      })
      await axios.get(`${baseApiUrl}Vigilantes/count?where={"qualificacao":"VIGILANTE DE GRANDES EVENTOS"}`).then(res => {
        this.qtdGrandesEventos = res.data.count
      })
      await axios.get(`${baseApiUrl}Vigilantes/count?where={"situacao":"EM ANÁLISE"}`).then(res => {
        this.qtdEmAnalise = res.data.count
      })
      await axios.get(`${baseApiUrl}Vigilantes/count?where={"situacao":"ATIVO"}`).then(res => {
        this.qtdAtivos = res.data.count
      })
      await this.calculaPercentuais()
    },

    close() {
      this.tipo = 0
      this.dialog = false
      this.corValidacao = '#424f4e'
      setTimeout(() => {
        this.validacao = false
      }, 300);
    },

    closeResultado() {
      if (this.acao == 'CHECKIN') {
        this.tipo = "1"
        this.validacao = false
        this.corValidacao = '#424f4e'
        this.participantes = 0
      } else
        this.close()
      //this.tipo = 1
    },

    async calculaPercentuais() {
      this.percenteReserv = this.reservados * 100 / this.capacidade
      this.percentInscri = this.inscritos * 100 / this.capacidade
      // this.percentConfirm = this.confirmados * 100 / this.capacidade
      this.percentConfirm = this.inscritosPagos * 100 / this.capacidade
      this.percentCheckinTotal = this.checkinsRealizadosTotal * 100 / this.inscritosPagos
      this.percentCheckinUser = this.checkinsRealizados * 100 / this.inscritosPagos
      this.isLoading = false
    },

  }
}
</script>

<style>
.v-data-table th {
  background-color: #90A4AE;
  font-size: 1rem;
  color: white;
}

.cardTema {
  background: #ECE9E6;
  background: -webkit-linear-gradient(to right, #FFFFFF, #ECE9E6);
  background: linear-gradient(to right, #FFFFFF, #ECE9E6);
}

.theme--light.v-table thead th {
  color: white;
}

.theme--light.v-datatable thead th.column.sortable:hover {
  color: rgb(17, 16, 16);
}

.span-pesquisa {
  width: 25%;
}

.container {
  position: relative;
  min-width: 100%;
  overflow: hidden;
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
</style>
